import { getDefaultState as getDefaultUiState } from '@ducks/ui';
import { getUserState } from '@user/redux/reducers';

export function getDefaultState() {
  const ui = getDefaultUiState();
  const user = getUserState();
  return {
    ui,
    user,
  };
}
